import {iconTerm} from '../../../../assets';
import {useAppContext, useBehavioralContext} from '../../../../contexts';
import {useTermAccept} from './useTermAccept';
import s from './termAccept.module.css';

const TermAccept = (props) => {
    // Destructured props
    const {
        handleCurrentStep,
        source = "default"
    } = props;

    // Component logic data
    const componentProps = useTermAccept({
        handleCurrentStep,
        source,
    });

    // Destructured component logic data
    const {
        check,
        handleChange,
        handleClick,
        convertStringToHtml
    } = componentProps;

    // Sidebar cart data
    const {sidebarCartData} = useBehavioralContext();

    // Accessibility feature dara
    const {highContrast} = useAppContext();

    // Prevents any runtime errors
    if (Object.keys(sidebarCartData.newProductData).length < 1) {
        return null;
    }

    // Retrieves term of use data
    const termUse =
        sidebarCartData.newProductData.productData.product.categories.find(category => {
            return category.name.toLowerCase() === (
                source === "default" ? "vacinas" : "exames laboratoriais"
            );
        }).termUse || "";

    // The title to be rendered at the top of the component
    const title = source === "default" ? "TERMOS DE USO - VACINAS" : "TERMOS DE USO";

    const termCheckWrapper = (
        <div className={"flex flex-col justify-center items-center w-full gap-[1rem]"}>
            <fieldset className={`
                flex flex-row items-center justify-start gap-x-2 bg-white border border-[#e5e5e5] rounded p-[1rem] w-full cursor-pointer 
                ${highContrast ? "highGrayColor border-white" : ""}
            `}>
                <input
                    type={"checkbox"}
                    id={"term-check-input"}
                    name={"termCheckButton"}
                    className={s.termCheckInput}
                    checked={check}
                    onInput={handleChange}
                />
                <label 
                    htmlFor={"term-check-input"} 
                    className={`
                        text-[13px] cursor-pointer font-bold
                        ${check ? "text-[#54a45c]" : "text-sabin-red-default"}
                        ${highContrast ? "highLabelFirst" : ""}
                    `}
                >
                    EU LI O CONTRATO E CONCORDO COM OS TERMOS E CONDIÇÕES DE USO.
                </label>
            </fieldset>
            <button 
                className={`
                    mb-[2.5rem] lg:mb-0 font-bold cursor-pointer
                    ${s.termCheckButton} rounded-full 
                    ${check 
                        ? `${highContrast ? "bg-contrast-yellow" : "bg-[#54a45c]"}` 
                        : `${highContrast ? "bg-[#ffedb3]" : "bg-[#b3ddc4]"}`} 
                    ${highContrast ? "text-black" : "text-white"}
                `}
                onClick={handleClick}
                disabled={!check}
            >
                PROSSEGUIR COM A COMPRA
            </button>
        </div>
    ) || null;

    return (
        <div className={`font-museo h-full ${s.root}`}>
            <div className={"flex items-center gap-x-5"}>
                <img
                    src={iconTerm}
                    alt={"icon term"}
                    className={highContrast ? "highImage" : ""}
                />
                <h1
                    className={`font-bold ${highContrast ? "highTitleFirst" : ""}`}>
                    {title}
                </h1>
            </div>

            <div className={"flex flex-col h-full"}>
                <div className="flex flex-1 max-h-[400px] overflow-y-auto my-4">
                    <p
                        className={`text-[#666] font-museo text-[14px] ${highContrast ? "highLabelFirst" : ""}`}
                        innerHTML={convertStringToHtml(termUse)}
                    />
                </div>
                <div className={"mb-24"}>
                    {termCheckWrapper}
                </div>
            </div>
        </div>
    )
}

export default TermAccept;
